import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  token: '',
  tokenValidado: false,
  alerta: {
    visible: false,
    mensaje: '',
    color: '',
    tiempo: -1
  },
  alerta2: {
    visible: false,
    mensaje: '',
    color: '',
    tiempo: -1
  },
  login: false
};
const getters = {
  getToken: state => state.token,
  getAlerta: state => state.alerta,
  getAlerta2: state => state.alerta2,
  getTokenValidado: state => state.tokenValidado,
  getLogin: state => state.login
};

const mutations = {
  inicializar(state) {
    state.token = localStorage.getItem('token');
  },
  setToken(state, payload) {
    localStorage.setItem('token', payload);
    state.token = payload;
  },
  setAlerta(state, {
    visible,
    mensaje,
    color,
    tiempo
  }) {
    state.alerta.visible = visible;
    state.alerta.mensaje = mensaje;
    state.alerta.color = color;
    state.alerta.tiempo = tiempo;
  },
  setAlerta2(state, {
    visible,
    mensaje,
    color,
    tiempo
  }) {
    state.alerta2.visible = visible;
    state.alerta2.mensaje = mensaje;
    state.alerta2.color = color;
    state.alerta2.tiempo = tiempo;
  },
  setTokenValidado(state, payload) {
    state.tokenValidado = payload;
  },
  setLogin(state, payload) {
    state.login = payload;
  }
};

const actions = {
  setToken({
    commit
  }, token) {
    commit('setToken', token);
  },
  setLogin({
    commit
  }, login) {
    commit('setLogin', login);
  },
  showAlerta({
    commit
  }, {
    mensaje,
    tipo,
    tiempo
  }) {
    let color;

    switch (tipo) {
      case 0:
        color = 'rgba(76, 175, 80)';
        break;
      case 1:
        color = 'rgba(255, 235, 59)';
        break;
      case 2:
        color = 'rgba(33, 250, 243)';
        break;
      case 3:
        color = 'rgba(244, 67, 54)';
        break;
      default:
        color = '';
        break;
    }

    if (typeof tiempo != "number") {
      tiempo = 3000;
    }

    commit('setAlerta', {
      visible: true,
      mensaje: mensaje,
      color: color,
      tiempo: tiempo
    });
  },
  hideAlerta({
    commit
  }) {
    commit('setAlerta', {
      visible: false,
      mensaje: ''
    });
  },
  showAlerta2({
    commit
  }, {
    mensaje,
    tipo,
    tiempo
  }) {

    let color;

    switch (tipo) {
      case 0:
        color = 'rgba(76, 175, 80)';
        break;
      case 1:
        color = 'rgba(255, 235, 59)';
        break;
      case 2:
        color = 'rgba(33, 250, 243)';
        break;
      case 3:
        color = 'rgba(244, 67, 54)';
        break;
      default:
        color = '';
        break;
    }

    if (typeof tiempo != "number") {
      tiempo = 3000;
    }

    commit('setAlerta2', {
      visible: true,
      mensaje: mensaje,
      color: color,
      tiempo: tiempo
    });
  },
  hideAlerta2({
    commit
  }) {
    commit('setAlerta2', {
      visible: false,
      mensaje: ''
    });
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
